// UI hints only. Existing delete endpoints independently enforce owner/payment rules.
export const gameRemoval = (record, type, id, userId) => {
  const isOwner = type === 'solo' || Boolean(userId && (type === 'group' ? record.host_id : record.creator_id) === userId);
  const hasValue = value => value != null && value !== '' && Number(value) !== 0;
  const protectedGame = type !== 'solo' && (
    ['entry_fee', 'entry_fee_cents', 'pot_total', 'prize_pool', 'total_pool'].some(field => hasValue(record[field])) ||
    Boolean(record.has_prize_pool || record.tournament_mode || record.entry_invites_sent) ||
    ['paid', 'processing', 'pending', 'completed', 'refunded'].includes(record.payment_status) ||
    Boolean(record.settlements?.length)
  );
  const deletePath = type === 'solo' ? `/scores/draft?draft_id=${encodeURIComponent(id)}` : type === 'group'
    ? `/group-rounds/${encodeURIComponent(id)}` : `/${type}/events/${encodeURIComponent(id)}`;
  return { isOwner, deletePath, removalLabel: type === 'solo' ? 'Discard draft' : 'Delete game',
    removalBlocked: isOwner && protectedGame ? 'Payment-protected game. Cancellation and any refunds must be reviewed before removal.' : '' };
};